"use client";
import { ReactNode, useState } from "react";
import Hero from "../Hero";
import { StickyNavMobile } from "../StickyNavMobile";
import { Accordion } from "@/types/Accordion";
import { HeroProps } from "../Hero/types";

type HubPageMobileProps = HeroProps & {
  accordions?: Accordion[];
  pageContent?: ReactNode;
  bannerCTA?: ReactNode;
  defaultAccordion?: string | null;
};

export const HubPageMobile = ({
  image,
  mb = "",
  bannerCTA,
  pageContent,
  mobileImage,
  slant,
  hasBreadcrumbs,
  accordions = [],
  showSlantStripe,
  defaultAccordion = null,
  ...props
}: HubPageMobileProps) => {
  const [openedAccordion, setOpenedAccordion] = useState<string | null>(null);

  return (
    <>
      <Hero
        {...props}
        image={image}
        showSlantStripe={showSlantStripe}
        mobileImage={mobileImage}
        hasBreadcrumbs={hasBreadcrumbs}
        slant={slant}
        mb={mb}
      >
        {pageContent}
        <span onClick={() => setOpenedAccordion(defaultAccordion)}>
          {bannerCTA}
        </span>
      </Hero>
      <StickyNavMobile
        handleAccordionClick={(accordion) => setOpenedAccordion(accordion)}
        defaultOpenedAccordion={openedAccordion}
        accordions={accordions}
      />
    </>
  );
};
